module.exports = __webpack_public_path__ + "static/media/xls.835cc8b5.png";